import { render, staticRenderFns } from "./UpgradeBoxData.vue?vue&type=template&id=228a0eb0&scoped=true&"
import script from "./UpgradeBoxData.vue?vue&type=script&lang=js&"
export * from "./UpgradeBoxData.vue?vue&type=script&lang=js&"
import style0 from "./UpgradeBoxData.vue?vue&type=style&index=0&id=228a0eb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228a0eb0",
  null
  
)

export default component.exports